// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const { keyedReviver } = require('client-v2/common/state/record-reviver')

class StumbleUponSubmitModalRecord extends Immutable.Record({
  addHref: String()
}) {
  // No methods
}

StumbleUponSubmitModalRecord.reviver = keyedReviver(StumbleUponSubmitModalRecord, {
  // No nested data structures
})

module.exports = StumbleUponSubmitModalRecord
